/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusObjektKategorieListResponseDto } from '../../models/lexplus-objekt-kategorie-list-response-dto';

export interface StammdatenControllerFindAllObjektKategorieV1$Params {

/**
 * Also return every Objekt, with its Objektkategorie and name.
 */
  withObjects?: boolean;
}

export function stammdatenControllerFindAllObjektKategorieV1(http: HttpClient, rootUrl: string, params?: StammdatenControllerFindAllObjektKategorieV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusObjektKategorieListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, stammdatenControllerFindAllObjektKategorieV1.PATH, 'get');
  if (params) {
    rb.query('withObjects', params.withObjects, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusObjektKategorieListResponseDto>;
    })
  );
}

stammdatenControllerFindAllObjektKategorieV1.PATH = '/v1/stammdaten/objektkategorien';
